import "./Breaks.css";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Form, Row, Col } from "react-bootstrap";
import ButtonCom from "../../../components/button/button";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { AgGridReact } from "ag-grid-react";
import AssignEmployee from "../../../components/AssignEmployee";
import { useDispatch, useSelector } from "react-redux";
import {
  commonSaveData,
  commonGetData,
  commonGetDataOne,
  commonGetDataFourth,
  initState,
  initCommonState,
} from "../../../redux/slices/commonSlice";

import {
  fetchBranchData,
  initBranchState,
} from "../../../redux/slices/branchSlice";

import {
  fetchDepartmentData,
  initDepartState,
} from "../../../redux/slices/departmentSlice.js";

import {
  getEmployeeDataOne,
  initEmpState,
} from "../../../redux/slices/employeeSlice.js";

import {
  getMyBreaksListPath,
  createMyBreaksPath,
  updateBreaksPath,
  deleteBreaksPath,
  getBreakStaffListPath,
  assignEmployeeBreakPath,
} from "../../../services/config";

import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";

import CustomPagination from "../../../components/CustomPagination";
import { HasPermission } from "../../../services/hasPermission";

import { useGlobalToast } from "../../../stopOldToastGlobally.js";

const Breaks = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.common);
  const departmentStore = useSelector((state) => state.department);
  const branchStore = useSelector((state) => state.branch);
  const employeeState = useSelector((state) => state.employee);

  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const toast = useGlobalToast();
  // Add theme detection
const themeStore = useSelector((state) => state.theme);
const isDark = themeStore?.theme === "dark" || !themeStore?.theme;
  const [open, setOpen] = useState(false);
  const [showAssign, setShowAssign] = useState(false);
  const [validated, setValidated] = useState(false);
  const [breakList, setBreakList] = useState([]);

  const [breakData, setBreakData] = useState({
    userId: user?.user_id,
    breakId: null,
    breakName: "",
    breakType: "",
    break_hour: "",
    break_minutes: "",
    logoutTime: "",
    exceededTime: "",
    isLogoutOrExceeded: "0",
    breakTime: "",
    breakTimeValue: "",
    bufferTime: "",
    bufferTimeValue: "",
    totalMinutes: 0, // Store total minutes
  });

  const [show, setShow] = useState(false);
  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isEdit, setIsEdit] = useState(false);
  const [delId, setDelId] = useState(null);

  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsersList, setSelectedUsersList] = useState([]);

  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [dbState, setDbState] = useState({
    branchId: "",
    departmentId: "",
  });

  const [searchQuery, setSearchQuery] = useState("");

  const isSelectAll =
    selectedUsers.length === employeeList.length && employeeList.length > 0;

  const [breakId, setBreakId] = useState("");

  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  // Helper function to format total minutes as "X Min" or "H:MM"
  const formatBreakTime = (totalMinutes) => {
    if (!totalMinutes || totalMinutes === 0) return "0 Min";
    
    if (totalMinutes < 60) {
      return `${totalMinutes} Min`;
    } else {
      const hours = Math.floor(totalMinutes / 60);
      const mins = totalMinutes % 60;
      return `${hours}:${mins.toString().padStart(2, '0')}`;
    }
  };

  // Helper function to convert hours and minutes to total minutes
  const convertToTotalMinutes = (hours, minutes) => {
    const h = parseInt(hours || 0);
    const m = parseInt(minutes || 0);
    return h * 60 + m;
  };

  const getBreakList = useCallback(() => {
    dispatch(commonGetData(`${getMyBreaksListPath}${user?.user_id}`));
    dispatch(fetchBranchData());
    dispatch(fetchDepartmentData(user.user_id));
  }, []);

  useEffect(() => {
    getBreakList();
  }, []);

  useEffect(() => {
    if (state.commonGetSuccess) {
      setBreakList(state.commonGetData);
      dispatch(initState());
    }
    if (state.commonGetError) {
    }

    if (departmentStore.depGetSuccess) {
      setDepartmentList(departmentStore.depGetData);
      dispatch(initDepartState());
    }

    if (branchStore.brnGetSuccess) {
      setBranchList(branchStore.brnGetData);
      dispatch(initBranchState());
    }
  }, [state, branchStore, departmentStore]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setBreakData({
      ...breakData,
      breakName: "",
      breakType: "",
      break_hour: "",
      break_minutes: "",
      logoutTime: "",
      exceededTime: "",
      isLogoutOrExceeded: "0",
      breakTime: "",
      breakTimeValue: "",
      bufferTime: "",
      bufferTimeValue: "",
      totalMinutes: 0,
    });
    setValidated(false);
    setOpen(false);
    setIsEdit(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (
      name == "bufferTimeValue" ||
      name == "breakTimeValue"
    ) {
      if (value.length < 4) {
        setBreakData({
          ...breakData,
          [name]: value,
        });
      }
      return;
    }
    
    setBreakData({
      ...breakData,
      [name]: value,
    });
  };

  // Increment break time by 15 minutes
  const incrementBreakTime = () => {
    const newTotal = (breakData.totalMinutes || 0) + 15;
    const hours = Math.floor(newTotal / 60);
    const mins = newTotal % 60;
    
    setBreakData({
      ...breakData,
      totalMinutes: newTotal,
      break_hour: hours.toString(),
      break_minutes: mins.toString(),
    });
  };

  // Decrement break time by 15 minutes
  const decrementBreakTime = () => {
    const currentTotal = breakData.totalMinutes || 0;
    if (currentTotal < 15) {
      // If less than 15, set to 0
      setBreakData({
        ...breakData,
        totalMinutes: 0,
        break_hour: "0",
        break_minutes: "0",
      });
      return;
    }
    
    const newTotal = currentTotal - 15;
    const hours = Math.floor(newTotal / 60);
    const mins = newTotal % 60;
    
    setBreakData({
      ...breakData,
      totalMinutes: newTotal,
      break_hour: hours.toString(),
      break_minutes: mins.toString(),
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setBreakData({
      ...breakData,
      [name]: checked ? "1" : "0",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    
    setValidated(true);
    
    // Validate that break time is set
    if (breakData.totalMinutes === 0) {
      toast.error("Please set break time (minimum 15 minutes)");
      return;
    }
    
    if (form.checkValidity() === false) {
      return;
    }
    
    const d = {
      path: createMyBreaksPath,
      data: breakData,
    };
    dispatch(commonSaveData(d));
  };

  useEffect(() => {
    if (state.commonSuccess) {
      handleClose();
      dispatch(initState());
      setBreakData({
        ...breakData,
        breakName: "",
        breakType: "",
        break_hour: "",
        break_minutes: "",
        logoutTime: "",
        exceededTime: "",
        isLogoutOrExceeded: "0",
        breakTime: "",
        breakTimeValue: "",
        bufferTime: "",
        bufferTimeValue: "",
        totalMinutes: 0,
      });
      getBreakList();
    }

    if (state.commonError) {
      handleClose();
      dispatch(initState());
      setBreakData({
        ...breakData,
        breakName: "",
        breakType: "",
        break_hour: "",
        break_minutes: "",
        logoutTime: "",
        exceededTime: "",
        isLogoutOrExceeded: "0",
        breakTime: "",
        breakTimeValue: "",
        bufferTime: "",
        bufferTimeValue: "",
        totalMinutes: 0,
      });
      getBreakList();
    }
  }, [state]);

  const handleEdit = (row) => {
    setIsEdit(true);
    const totalMins = convertToTotalMinutes(row.break_duration_hour, row.break_duration_minutes);
    
    setBreakData({
      ...breakData,
      breakId: row.breakId,
      breakName: row.break_name,
      breakType: row.break_type,
      break_hour: row.break_duration_hour,
      break_minutes: row.break_duration_minutes,
      totalMinutes: totalMins,
      logoutTime: row.logoutTime,
      exceededTime: row.exceededTime,
      isLogoutOrExceeded: row.isLogoutOrExceeded,
      breakTime: row.breakTime,
      breakTimeValue: row.breakTimeValue,
      bufferTime: row.bufferTime,
      bufferTimeValue: row.bufferTimeValue,
    });
    handleClickOpen();
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    setValidated(true);
    
    // Validate that break time is set
    if (breakData.totalMinutes === 0) {
      toast.error("Please set break time (minimum 15 minutes)");
      return;
    }
    
    let d = {
      path: updateBreaksPath,
      data: breakData,
    };
    dispatch(commonSaveData(d));
  };

  const handleDelete = (row) => {
    setDelId(row.breakId);
    handleShow();
  };

  const handleDeleteSubmit = () => {
    let d = {
      path: deleteBreaksPath,
      data: {
        userId: user?.user_id,
        breakId: delId,
      },
    };
    dispatch(commonSaveData(d));
    handleModalClose();
  };

  useEffect(() => {
    if (state.commonSuccess) {
      toast.success(state.commonMessage);
      setOpen(false);
      getBreakList();
      setIsEdit(false);
      closeAssign();
      dispatch(initCommonState());
    }
    if (state.commonError) {
      toast.error(state.commonMessage);
      setOpen(false);
      getBreakList();
      closeAssign();
      dispatch(initCommonState());
    }

    if (employeeState.empGetSuccessOne) {
      const data = employeeState.empGetDataOne;

      if (searchQuery != "") {
        searchEmployees(searchQuery, data)
      } else {
        setEmployeeList(data);
        setFilterEmployeeList(data);

        const slU = data
          ?.filter((v) => v.breakAssignedStatus === "1")
          .map((v) => v.staffId);
        setSelectedUsers(slU);

        const list = data
          ?.filter((v) => v.breakAssignedStatus === "1")
          .map((v) => v);
        setSelectedUsersList(list);
      }
      dispatch(initEmpState())
    }
  }, [state, employeeState]);

const columns = [
  {
    headerName: "S.No",
    cellRenderer: (params) => {
      // Calculate serial number based on current page and row index
      const currentPage = params.api.paginationGetCurrentPage();
      const pageSize = params.api.paginationGetPageSize();
      const rowIndex = params.node.rowIndex;
      return currentPage * pageSize + rowIndex + 1;
    },
    width: 100,
    cellStyle: { 
      textAlign: 'center',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    headerClass: 'text-center',
  },
  {
    headerName: "Break Name",
    cellRenderer: (row) => row.data.break_name,
    flex: 1,
  },
  {
    headerName: "Duration Hour",
    cellRenderer: (row) => row.data.break_duration_hour + " h",
    cellStyle: { textAlign: 'center' },
  },
  {
    headerName: "Duration Minutes",
    cellRenderer: (row) => row.data.break_duration_minutes + " m",
    cellStyle: { textAlign: 'center' },
  },
  {
    headerName: "Status",
    cellRenderer: (rowData) => {
      return rowData.data.status == 1 ? "Active" : "InActive";
    },
    cellStyle: { textAlign: 'center' },
  },
  {
    headerName: "Actions",
    width: "200px",
    cellRenderer: (row) => {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          {HasPermission("Break", "create") && (
            <PiUserCheck
              style={{
                cursor: "pointer",
                fontSize: 25,
              }}
              className="assign-icon"
              onClick={() => {
                handleAssignId(row.data);
              }}
            />
          )}

          {HasPermission("Break", "edit") && (
            <PiPencilSimpleLineBold
              style={{
                cursor: "pointer",
                fontSize: 25,
              }}
              className="edit-icon"
              onClick={() => {
                handleEdit(row.data);
              }}
            />
          )}

          {HasPermission("Break", "delete") && (
            <RiDeleteBinLine 
              className="delete-icon"
              style={{ cursor: "pointer", fontSize: 25, color: "red" }}
              onClick={() => handleDelete(row.data)}
            />
          )}

          {!HasPermission("Break", "edit") &&
            !HasPermission("Break", "delete") &&
            "-"}
        </div>
      );
    },
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: "200px",
    cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  },
];

  const paginationPageSize = 10;
  const preSubmit = () => {
    let elem = document.querySelector("#submitBtn");
    if (elem) {
      elem.click();
    }
  };

  const openAssign = () => {
    setShowAssign(true);
  };

  const closeAssign = () => {
    setShowAssign(false);
    setSearchQuery("")
    setDbState((pre) => ({
      ...pre,
      branchId: "",
      departmentId: "",
    }))
  };

  useEffect(() => {
    const path = getBreakStaffListPath(user.user_id, breakId, dbState.branchId, dbState.departmentId);
    dispatch(getEmployeeDataOne(path));
  }, [breakId, dbState.branchId, dbState.departmentId])

  const [outletName, setOutletName] = useState("");

  const handleAssignId = (data) => {
    setBreakId(data.breakId);
    setOutletName(data.break_name);
    setTimeout(() => {
      openAssign();
    });
  };

  const selectUser = (event, userId, user) => {
    const isChecked = event.target.checked;
    setSelectedUsers((prevSelected) => {
      const updatedList = isChecked
        ? [...prevSelected, userId]
        : prevSelected.filter((id) => id !== userId);
      return updatedList;
    });

    setSelectedUsersList((prevSelected) =>
      isChecked
        ? [...prevSelected, user]
        : prevSelected.filter((u) => u.staffId !== user.staffId)
    );
  };

  const SelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allUserIds = employeeList.map((row) => row.staffId);
      setSelectedUsers(allUserIds);
      const allUserList = employeeList.map((row) => row);
      setSelectedUsersList(allUserList);
    } else {
      setSelectedUsers([]);
      setSelectedUsersList([]);
    }
  };

  const searchEmployees = (val, dataList) => {
    setSearchQuery(val);
    const filteredEmployees = dataList.filter(
      (v) =>
        v.full_name.toLowerCase().includes(val.toLowerCase()) ||
        v.employee_id.toLowerCase().includes(val.toLowerCase())
    );
    setEmployeeList(filteredEmployees);
    setFilterEmployeeList(dataList)
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setDbState((preState) => ({
      ...preState,
      [name]: value,
    }));
  };

  const handleAssignBreakSubmit = (e) => {
    e.preventDefault();
    const data = {
      path: assignEmployeeBreakPath,
      data: {
        userId: user.user_id,
        staffId: selectedUsers.toString(),
        breakId: breakId,
      },
    };
    dispatch(commonSaveData(data));
  };

  const [backPath, setBackPath] = useState("/setting/")

  useEffect(() => {
    if (localStorage.getItem("emp-redirect")) {
      setBackPath(localStorage.getItem("emp-redirect"))
    } else {
      setBackPath("/setting/")
    }
  }, [])

  return (
    <div
      className="SettingBody"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "100%",
        backgroundColor: "transparent",
      }}
    >
      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title className="color-white">Delete Break</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "gray",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={handleModalClose}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "red", color: "#fff" }}
            onClick={handleDeleteSubmit}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <div
        className="SettingBody-card mt-1"
        style={{ width: "100%", backgroundColor: "transparent" }}
      >
        <Widgets
          icon={
            <WidgetsIcon
              icon={
                <Link to={backPath} className="icon-color">
                  <ArrowBackIcon />
                </Link>
              }
              title="Company Breaks"
            />
          }
          button={
            HasPermission("Break", "create") && (
              <ButtonCom
                type={"button"}
                class_name={"universal-btn border-radius-8px"}
                text={"Add Break"}
                ext
                url_or_onclick={handleClickOpen}
                icon={<AddIcon />}
                width={""}
              />
            )
          }
          body={
            <>
              <div
                className="ag-theme-quartz custom-grid"
                style={{
                  height: "calc(100vh - 220px)",
                  width: "100%",
                  padding: "20px",
                }}
              >
                <AgGridReact
                  rowData={Array.isArray(breakList) ? breakList : []}
                  columnDefs={columns}
                  domLayout="autoHeight"
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                />
              </div>
              <div className="d-flex align-items-center justify-content-between custom-pagination">
                {gridApi && <CustomPagination gridApi={gridApi} />}
              </div>
            </>
          }
        />

        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={open}
          onClose={handleClose}
        >
          <DialogTitle id="alert-dialog-title" className="dialog-title">
            <div className="dialog-title-icon">
              <span className="close-icon" onClick={handleClose}>
                X
              </span>
              <span className="title">
                {isEdit ? "Update Break" : "Add New Break"}
              </span>
            </div>
            <button className="universal-btn" onClick={preSubmit}>
              {isEdit ? "Update" : "Add"}
            </button>
          </DialogTitle>

          <div style={{ overflow: "auto" }}>
            <Form
              noValidate
              validated={validated}
              onSubmit={isEdit ? handleEditSubmit : handleSubmit}
            >
              <DialogContent>
                <Row>
                  <Col sm="12">
                    <Form.Group className="mb-3">
                      <Form.Label className="color-white">
                        Break Name <span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="breakName"
                        value={breakData.breakName}
                        placeholder="Enter Break Name"
                        onChange={handleChange}
                        className="universal-input"
                        required
                      />
                      <Form.Control.Feedback type={"invalid"}>
                        Please provide valid break name.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                {/* SINGLE BREAK TIME INPUT WITH +/- BUTTONS */}
                {/* SINGLE BREAK TIME INPUT WITH +/- BUTTONS */}
<Row>
  <Col sm="12">
    <Form.Group className="mb-3">
      <Form.Label style={{
        color: isDark ? "#e2e8f0" : "#2d3748",
        fontWeight: "500",
        marginBottom: "8px",
        display: "block"
      }}>
        Break Time <span style={{ color: "#fc8181" }}> *</span>
      </Form.Label>
      
      <div style={{ 
        display: "flex", 
        alignItems: "center",
        background: isDark ? "#402d48" : "#c2c2c45b",
        borderRadius: "8px",
        border: `2px solid ${isDark ? "#4a5568" : "#97979737"}`,
        overflow: "hidden",
        transition: "all 0.2s ease",
        maxWidth: "320px",
        height: "42px",
        position: "relative"
      }}>
        {/* Decrease button */}
        <button
          type="button"
          onClick={decrementBreakTime}
          style={{
            width: "40px",
            height: "100%",
            border: "none",
            background: "transparent",
            color: isDark ? "#a0aec0" : "#4a5568",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            fontSize: "20px",
            fontWeight: "bold",
            transition: "all 0.2s ease",
            borderRight: `1px solid ${isDark ? "#4a5568" : "#cbd5e0"}`,
            flexShrink: 0
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = isDark ? "rgba(74, 85, 104, 0.4)" : "rgba(203, 213, 224, 0.4)";
            e.currentTarget.style.color = isDark ? "#b663ed5b" : "#351a4a53";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = isDark ? "#a0aec0" : "#4a5568";
          }}
        >
          <span style={{ marginTop: "-2px" }}>-</span>
        </button>

        {/* Display field */}
        <div
          style={{
            flex: 1,
            padding: "0 12px",
            textAlign: "center",
            background: "transparent",
            color: isDark ? "#e2e8f0" : "#2d3748",
            fontSize: "14px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "100px"
          }}
        >
          {formatBreakTime(breakData.totalMinutes)}
        </div>

        {/* Increase button */}
        <button
          type="button"
          onClick={incrementBreakTime}
          style={{
            width: "40px",
            height: "100%",
            border: "none",
            background: "transparent",
            color: isDark ? "#a0aec0" : "#4a5568",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            fontSize: "20px",
            fontWeight: "bold",
            transition: "all 0.2s ease",
            borderLeft: `1px solid ${isDark ? "#4a5568" : "#cbd5e0"}`,
            flexShrink: 0
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = isDark ? "rgba(84, 67, 98, 0.4)" : "rgba(203, 213, 224, 0.4)";
            e.currentTarget.style.color = isDark ? "#ad80e54a" : "#351a4a53";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = isDark ? "#a0aec0" : "#4a5568";
          }}
        >
          <span style={{ marginTop: "-2px" }}>+</span>
        </button>
      </div>
      
      {/* Hours conversion label */}
      <div style={{ 
        fontSize: "12px", 
        marginTop: "8px",
        color: isDark ? "#a0aec0" : "#4a5568",
        fontWeight: "500",
        display: "flex",
        alignItems: "center",
        gap: "4px"
      }}>
        <span style={{
          background: isDark ? "rgba(66, 153, 225, 0.1)" : "rgba(49, 130, 206, 0.1)",
          color: isDark ? "#afb6bc" : "#3a184b60",
          padding: "4px 8px",
          borderRadius: "4px",
          fontWeight: "600"
        }}>
          {breakData.totalMinutes} min = {Math.floor(breakData.totalMinutes / 60)} hr {breakData.totalMinutes % 60 > 0 ? `${breakData.totalMinutes % 60} min` : ''}
        </span>
      </div>
      
      {validated && breakData.totalMinutes === 0 && (
        <div style={{ 
          color: "#fc8181", 
          fontSize: "11px", 
          marginTop: "4px",
          fontWeight: "500"
        }}>
          Please set break time (minimum 15 minutes).
        </div>
      )}
    </Form.Group>
  </Col>
</Row>

                  <Row>
                    <Col sm="12" className="mt-2">
                      <Form.Group>
                        <Form.Check
                          className="color-white"
                          type="radio"
                          name="isLogoutOrExceeded"
                          value={"1"}
                          label="Log out the user if break time exceeds"
                          checked={breakData.isLogoutOrExceeded == "1"}
                          onChange={(e) =>
                            setBreakData({
                              ...breakData,
                              isLogoutOrExceeded: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col sm="6" className="mt-2">
                      <center>
                        <span
                          className="color-white"
                          style={{ position: "relative", top: "-3px" }}
                        >
                          OR
                        </span>
                      </center>
                    </Col>

                    <Col sm="12">
                      <Form.Group>
                        <Form.Check
                          className="color-white"
                          type="radio"
                          name="isLogoutOrExceeded"
                          value="2"
                          label="Deduct only the exceeded time from working hours"
                          checked={breakData.isLogoutOrExceeded == "2"}
                          onChange={(e) =>
                            setBreakData({
                              ...breakData,
                              isLogoutOrExceeded: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col sm="12" className="mt-1">
                      <Form.Group>
                        <Form.Check
                          className="color-white"
                          type="checkbox"
                          name="breakTime"
                          label="Enable break time notification"
                          checked={breakData.breakTime == "1"}
                          onChange={(e) =>
                            setBreakData({
                              ...breakData,
                              breakTime: e.target.checked ? "1" : "0",
                            })
                          }
                        />

                        {breakData.breakTime == "1" && (
                          <Form.Control
                            className="universal-input mt-2 mb-2"
                            type="text"
                            name="breakTimeValue"
                            value={breakData.breakTimeValue}
                            placeholder="Enter notification time in minutes"
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </Col>

                    <Col sm="12" className="mt-1">
                      <Form.Group>
                        <Form.Check
                          className="color-white"
                          type="checkbox"
                          name="bufferTime"
                          label="Enable buffer time"
                          checked={breakData.bufferTime == "1"}
                          onChange={(e) =>
                            setBreakData({
                              ...breakData,
                              bufferTime: e.target.checked ? "1" : "0",
                            })
                          }
                        />

                        {breakData.bufferTime == "1" && (
                          <Form.Control
                            className="universal-input grayPlaceholder mt-2 mb-2"
                            type="text"
                            name="bufferTimeValue"
                            value={breakData.bufferTimeValue}
                            placeholder="Enter buffer time in minutes"
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    color="info"
                    type="submit"
                    style={{
                      fontWeight: "300",
                      fontSize: "14px",
                      height: "30px",
                      width: "100px",
                      display: "none",
                    }}
                    className="universal-btn"
                    id="submitBtn"
                  >
                    Save
                  </Button>
                </DialogActions>
              </Form>
            </div>
          </Dialog>

          <AssignEmployee
            isOpen={showAssign}
            closeOpenDialog={closeAssign}
            submitData={handleAssignBreakSubmit}
            isSelectAll={isSelectAll}
            SelectAll={SelectAll}
            selectedUsersList={selectedUsersList}
            employeeList={employeeList}
            selectedUsers={selectedUsers}
            selectUser={selectUser}
            branchList={branchList}
            departmentList={departmentList}
            state={dbState}
            handleInputChange={handleInputChange}
            getData={""}
            searchQuery={searchQuery}
            searchEmployees={searchEmployees}
            outletName={outletName}
            dataList={filterEmployeeList}
          />
        </div>
      </div>
    );
  };

  export default Breaks;